module.exports = __webpack_public_path__ + "img/digitization-population.899b7527.svg";